import { queryOptions } from '@tanstack/react-query'
import { assetGet } from 'Asset/api/AssetsApi'

import { RequestStaleTime } from 'Common/utils/helpers/HelperQuery'

export const assetQueries = {
    all: () => ['assets'],
    details: () => [...assetQueries.all(), 'detail'],
    detail: (id: number) =>
        queryOptions({
            queryKey: [...assetQueries.details(), id],
            queryFn: () => assetGet(id),
            staleTime: RequestStaleTime.default,
        }),
}
